export const validateRequired = (value) =>
  value ? undefined : 'Please complete';

export const validateEmail = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,7}$/i.test(value)
    ? 'Please enter a valid email'
    : undefined;
